import { useMemo } from "react";

import { Column } from "@covertree/ui/table/types";

import { QuoteListItemsSortBy } from "@covertree/agent-portal-graphql";

export const useGetQuotesColumns = (): Column[] => {
  return useMemo(() => {
    return [
      { headerName: "Policy ID" },
      { headerName: "Quote ID" },
      { headerName: "Name" },
      { headerName: "Address" },
      { headerName: "Type" },
      { headerName: "Premium" },
      { headerName: "Assigned Agent" },
      { headerName: "Assigned Agency" },
      {
        headerName: "Created Date",
        sortBy: QuoteListItemsSortBy.CreatedTimestamp,
      },
      {
        headerName: "Last Activity Date",
        sortBy: QuoteListItemsSortBy.UpdatedTimestamp,
      },
    ];
  }, []);
};
